import { FC } from 'react';
import { Text } from '@qga/roo-ui/components';

const Label: FC = ({ children }) => (
  <Text display={['none', 'block']} as="div" color="greys.steel" mb={0} lineHeight="tight" pb="1">
    {children}
  </Text>
);
export default Label;
